import * as React from "react";
import { THEMES } from "./Themes";
import ActivityLegend from "./ActivityRingsLegend";
import Rings from "./Rings";
import PieFactory from "./PieFactory";
const defaultCfg = {
    width: 150,
    height: 150,
    ringSize: 14,
    radius: 32
};
const ActivityRingsBase = ({ data, config, theme, legend, legendTitle }) => {
    const cfg = Object.assign(Object.assign({}, defaultCfg), config);
    const backPie = PieFactory.create(data, cfg.height, cfg.radius, [
        0.999,
        0.001
    ]);
    const frontPie = PieFactory.create(data, cfg.height, cfg.radius);
    const selectedTheme = THEMES[theme || "dark"];
    return (React.createElement("div", { style: styles.layout },
        React.createElement("div", { style: Object.assign(Object.assign({}, styles.container), { width: cfg.width, height: cfg.height }) },
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: cfg.width, height: cfg.height },
                React.createElement("g", { transform: `translate(${cfg.width / 2},${cfg.height / 2})` },
                    React.createElement(Rings, { size: cfg.ringSize, pie: backPie, data: data, theme: selectedTheme, opacity: true }),
                    React.createElement(Rings, { size: cfg.ringSize, pie: frontPie, data: data, theme: selectedTheme, opacity: false })))),
        legend && (React.createElement(ActivityLegend, { title: legendTitle, data: data, theme: theme }))));
};
ActivityRingsBase.defaultProps = {
    data: [],
    theme: "dark",
    legend: false
};
const styles = {
    layout: {
        display: "flex",
        alignItems: "center"
    },
    container: {
        display: "flex"
    }
};
const ActivityRings = React.memo(ActivityRingsBase);
export default ActivityRings;
